import { MediaDisplay } from "@package/ui-wall-components";
import { useTriviaContext } from "../context-trivia";
import { TriviaButton } from "../TriviaButton/TriviaButton";

export function TriviaWelcome() {
  const { config, start } = useTriviaContext();
  const { welcome } = config;

  return (
    <div className="flex h-full min-h-0 w-full flex-col items-center justify-center gap-[var(--trivia-space)] px-[var(--trivia-space)] text-center">
      {!!welcome.media && (
        <div className="max-h-[30cqb] max-w-full">
          <MediaDisplay
            id={welcome.media}
            alt={welcome.title ?? ""}
            classNameMedia="max-h-[30cqb] max-w-full object-contain"
          />
        </div>
      )}
      {!!welcome.title && (
        <div
          className="hyphens-auto text-balance break-words font-bold"
          style={{ fontSize: "var(--trivia-text-display)" }}
        >
          {welcome.title}
        </div>
      )}
      {!!welcome.introText && (
        <div
          className="text-balance break-words"
          style={{
            fontSize: "var(--trivia-text-body)",
            color: config.theme.secondaryTextColor,
          }}
        >
          {welcome.introText}
        </div>
      )}
      <TriviaButton text={welcome.startButtonLabel} onHandleMouse={start} />
    </div>
  );
}
